module.exports = __webpack_public_path__ + "static/media/completed-consultations.74622b80.png";